var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 625336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 625335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 625334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 625333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 625332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 625331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.716521 11.7422L0.0195313 12.0377C0.0194857 12.2143 0.0874347 12.3896 0.220006 12.5217L11.2052 23.4685C11.3334 23.5962 11.5536 23.6663 11.6829 23.6669C11.8142 23.6675 12.0388 23.5983 12.1693 23.4683L23.1526 12.5147C23.2848 12.3828 23.3527 12.2079 23.3529 12.0316L22.7468 11.7422C22.4089 11.7422 19.2703 11.7422 15.4568 11.7422L11.3676 13.0622L7.90913 11.7422C4.32187 11.7422 1.33403 11.7422 0.716521 11.7422Z",
    fill: "#FFB739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.3525 12.0317C23.3525 12.2078 23.2847 12.3826 23.1522 12.5146L12.169 23.4682C12.0397 23.5975 11.8171 23.6667 11.686 23.6667V12.9593L15.4567 11.7422H22.7467L23.3525 12.0317Z",
    fill: "#FF9441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.90918 11.7422L11.6863 23.6667L15.4569 11.7422H7.90918Z",
    fill: "#FF9441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.4566 11.7422L11.686 23.6667V11.7422H15.4566Z",
    fill: "#FF7149"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.2382 11.6521L19.5821 6.1741C19.5315 6.09836 19.4663 6.03401 19.3913 5.98434L19.0599 6.14348L12.3187 6.1855L11.6862 5.87036L11.175 6.19261L4.44897 6.23453L3.97962 5.98502C3.90511 6.03456 3.84017 6.09868 3.78967 6.17447L0.133782 11.6593C0.0568097 11.7748 0.0195312 11.9066 0.0195312 12.0376C1.34392 12.0372 21.6422 12.0319 23.3528 12.0314C23.3529 11.9 23.3155 11.7678 23.2382 11.6521Z",
    fill: "#FFD17E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.3525 12.0316C22.505 12.0316 17.0921 12.0334 11.686 12.0348V5.87036L12.3187 6.18531L19.0598 6.14343L19.3912 5.98411C19.4663 6.0342 19.5313 6.09836 19.5819 6.17392L23.2383 11.6519C23.3156 11.768 23.3529 11.9 23.3525 12.0316Z",
    fill: "#FFB739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.35796 5.87036C4.22142 5.87036 4.09045 5.91142 3.97998 5.98493L8.02939 12.0355H8.02985L11.6861 5.87036H4.35796Z",
    fill: "#FFB739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.3441 12.0335L19.3912 5.9842C19.281 5.91115 19.1504 5.87036 19.0143 5.87036H11.686L15.3412 12.0336H15.3441V12.0335Z",
    fill: "#FF9441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.60386 16.8C6.46113 16.8 5.5314 15.8703 5.5314 14.7275C5.5314 14.35 5.22533 14.0439 4.84781 14.0439C4.47028 14.0439 4.16421 14.35 4.16421 14.7275C4.16421 15.8645 3.24014 16.8 2.09179 16.8C1.71427 16.8 1.4082 17.106 1.4082 17.4835C1.4082 17.8611 1.71427 18.1671 2.09179 18.1671C3.23453 18.1671 4.16421 19.0968 4.16421 20.2396C4.16421 20.6171 4.47028 20.9232 4.84781 20.9232C5.22533 20.9232 5.5314 20.6171 5.5314 20.2396C5.5314 19.1027 6.45538 18.1671 7.60386 18.1671C7.98139 18.1671 8.28745 17.8611 8.28745 17.4835C8.28745 17.106 7.98139 16.8 7.60386 16.8Z",
    fill: "#FFD17E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M18.0814 3.08951C16.9386 3.08951 16.0089 2.15982 16.0089 1.01709C16.0089 0.639563 15.7029 0.333496 15.3253 0.333496C14.9478 0.333496 14.6418 0.639563 14.6418 1.01709C14.6418 2.15982 13.7121 3.08951 12.5693 3.08951C12.1918 3.08951 11.8857 3.39557 11.8857 3.7731C11.8857 4.15062 12.1918 4.45669 12.5693 4.45669C13.7121 4.45669 14.6418 5.38637 14.6418 6.52911C14.6418 6.90663 14.9478 7.2127 15.3253 7.2127C15.7029 7.2127 16.0089 6.90663 16.0089 6.52911C16.0089 5.38637 16.9386 4.45669 18.0814 4.45669C18.4589 4.45669 18.7649 4.15062 18.7649 3.7731C18.7649 3.39557 18.4589 3.08951 18.0814 3.08951Z",
    fill: "#FFB739"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiamond);
export default __webpack_public_path__ + "static/media/icon_diamond.b7f9ec02f20033ad6ccd87bf8b7f4e5e.svg";
export { ForwardRef as ReactComponent };